import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  surchargePanel: createResponsiveStyles({
    base: {
      backgroundColor: theme.colors.light.base,
      flex: 1,
      borderRadius: theme.spacing.xsmall,
      justifyContent: "space-between",
    },
    medium: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  }),
  surchargeItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
    alignItems: "center",
  },
  surchargeLastItem: {
    borderBottomColor: "transparent",
    paddingBottom: theme.spacing.small,
    borderBottomLeftRadius: theme.spacing.xsmall,
  },
  surchargeFirstItem: {
    paddingTop: theme.spacing.small,
    borderTopLeftRadius: theme.spacing.xsmall,
  },
  surchargeItemContent: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    height: "100%",
    borderBottomColor: theme.colors.greyscale.lightest,
    borderBottomWidth: 1,
    marginHorizontal: theme.spacing.medium,
  },
  surchargeImage: {
    width: theme.spacing.xlarge,
    height: theme.spacing.xlarge,
    marginLeft: -theme.spacing.xsmall,
  },
  overlay: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: `${theme.colors.dark.base}AA`,
    zIndex: 1,
  },
  surchargeTextContainer: {
    flex: 1,
    justifyContent: "center",
  },
});
